export class QuestionAnswerData {
    totalNumberOfQuestions: number;
    questionsAnswered: number;
    complete: boolean;

    constructor(totalQuestions: number, numberAnswered: number) {
        this.totalNumberOfQuestions = totalQuestions;
        this.questionsAnswered = numberAnswered;
        this.complete = this.totalNumberOfQuestions == this.questionsAnswered;
    }
}
